export function firstNameFrom(fullName?: string | null, email?: string | null): string | null {
  const name = String(fullName || '').trim();
  if (name) return name.split(/\s+/)[0] || null;
  const local = String(email || '').split('@')[0].replace(/[._]+/g, ' ').trim();
  if (local) return local.split(/\s+/)[0] || null;
  return null;
}

export function welcomeMessage(fullName?: string | null, email?: string | null): string {
  const first = firstNameFrom(fullName, email);
  return first ? `Welcome, ${first}` : 'Welcome';
}
